export default __webpack_public_path__ + "static/media/btn-blue-m.1fefe8d1.webp";